import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectionStrategy, Component, OnInit, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation, ElementRef, Input, ChangeDetectorRef } from '@angular/core';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NotificationSearchService } from '../notification-search/notification-search.service';
import { AppUtils } from 'projects/dialog/src/app/shared/utilities/app-utils';
import { FeedbackDetailsComponent } from '../feedback-details/feedback-details.component';
import { recepientTableColumns, recepientTableInit } from '../../constants';
import { NotificationAddRecipientsTemplateDialogComponent } from '../notification-add-recipients-template-dialog/notification-add-recipients-template-dialog.component';
import { Subject } from 'rxjs';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import qnsbnurlAPI from '../../services/qn-sbn-API-url';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { FilterOverlayDialogService } from '../filter-overlay-dialog/filter-overlay-dialog.service';
import { FilterOptions } from '../filter-overlay-dialog/filter-overlay-dialog.component';
import { filter } from 'rxjs/operators';
import { ResendDetailsComponent } from '../resend-details/resend-details.component';

@Component({
  selector: 'dl-notification-recipients-table',
  templateUrl: './notification-recipients-table.component.html',
  styleUrls: ['./notification-recipients-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationRecipientsTableComponent implements OnInit, OnChanges {
  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  @ViewChild('exporter', { static: true }) exporter: ElementRef;
  @Input() notificationDetails: any;
  @Input() selectedRecepientColumns: any;
  @Input() contactDetails: any;
  @Input() notificationLabel: any;
  @Input() accDataObj: any;

  public fileData = [];
  public columnData: any;
  public displayedColumns = ['select', 'CustomerName', 'DateSent', 'DateDelivered', 'DateRead', 'FeedbackReceived', 'Status', 'Arrow'];
  public dataSource = new MatTableDataSource<any>();
  public selection = new SelectionModel(true, []);
  public selectedRow: any;
  public filterArray: any[] = [];
  public filteredData: any;
  public downloadArray: any[] = [];
  public headerList: any[] = recepientTableColumns;
  public userPermission: any;
  public isAddRecipientDisabled = false;
  public isAfoBtnDisabled = false;
  public isAfoBtnExpanded = false;
  public isNewFromTemplate = false;
  public templateData: any;
  public templateColumn = ['dragHandle', 'selectType', 'selectText', 'iconSets'];
  public filteredStatusList: any;
  public updateFeedbackOptions: Subject<any> = new Subject<any>();
  public isResend: boolean = true;
  @Input() isSetCom: boolean = false;

  public constructor(public appUtils: AppUtils, public filterOverlay: FilterOverlayDialogService, public readonly oneSnackBar: OneSnackBarService, public qnsbnService: QnSbnService, public notificationSearchService: NotificationSearchService, public router: Router, public changeDetectorRef: ChangeDetectorRef, public readonly dialog?: MatDialog, public readonly resendDialog?: MatDialog) {}

  public ngOnInit(): void {  
    this.userPermission = this.qnsbnService.getUserData();
    if (this.selectedRecepientColumns > 0) {
      const recipientColumns = ['select'];
      let selectedColumns = this.selectedRecepientColumns.map(columnValue => columnValue.value);
      recepientTableColumns.forEach(colObj => {
        if (selectedColumns.indexOf(colObj.value) !== -1) {
          recipientColumns.push(colObj.value);
        }
      });
      recipientColumns.push('Arrow');
      this.displayedColumns = recipientColumns;
    }
    this.sort.sort(({ id: 'CustomerName', start: 'asc'}) as MatSortable);
    this.dataSource.sort = this.sort;
    this.dataSource.data = this.contactDetails;
    if (this.contactDetails.length > 0) {
      this.filteredStatusList = this.contactDetails.map(item => item.Status).filter((value, index, self) => self.indexOf(value) === index);
      this.filterOverlay.setStatusName(this.filteredStatusList);
    }
    this.notificationSearchService.searchData$.subscribe(searchValue => {
      this.dataSource.filter = searchValue;
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        return this.appUtils.getLowerCase(data.CustomerName).includes(filter.toLowerCase()) || this.appUtils.getLowerCase(data.DateSent).includes(filter.toLowerCase()) || 
        this.appUtils.getLowerCase(data.DateDelivered).includes(filter.toLowerCase()) || this.appUtils.getLowerCase(data.DateRead).includes(filter.toLowerCase()) || 
        this.appUtils.getLowerCase(data.FeedbackReceived).includes(filter.toLowerCase()) || this.appUtils.getLowerCase(data.Status).includes(filter.toLowerCase()) || 
        this.appUtils.getLowerCase(data.CustomerContactName).includes(filter.toLowerCase()) || this.appUtils.getLowerCase(data.CustomerContactEmail).includes(filter.toLowerCase());
      };
      this.changeDetectorRef.detectChanges();
    });
    this.filterOverlay.filterData$.subscribe(filterValue => {
      // console.log('value of all filters', filterValue);
      this.filterSourceTable(filterValue);
    });
    this.isAddRecipientDisabled = this.notificationDetails.notificationData[0].Status === 'Complete' || this.notificationDetails.notificationData[0].Status === 'Completed';
  }
  public ngOnChanges(changes: SimpleChanges): void {
    // console.log('onchange--->',changes)
    this.userPermission = this.qnsbnService.getUserData();
    if(changes.selectedRecepientColumns){
      const currentChanges = changes.selectedRecepientColumns.currentValue;
      if (currentChanges.length > 0) {
        const recipientColumns = ['select'];
        let selectedColumns = currentChanges.map(columnValue => columnValue.value);
        recepientTableColumns.forEach(colObj => {
          if (selectedColumns.indexOf(colObj.value) !== -1) {
            recipientColumns.push(colObj.value);
          }
        });
        recipientColumns.push('Arrow');
        this.displayedColumns = recipientColumns;
      }
    }
    this.dataSource.data = this.contactDetails;
    if(this.isAddRecipientDisabled){
      this.isSetCom = true;
    }
    this.changeDetectorRef.detectChanges();
  }
  public isAllSelected($event) {
    const numSelected = this.selection.selected.length;
    const numDisabled = this.dataSource.data.filter(row => row.disabled).length;
    const numRows = this.dataSource.data.length;
    return numSelected + numDisabled === numRows;
  }
  public masterToggle($event) {
    this.isAllSelected($event) ? this.selection.clear() : this.dataSource.data.forEach(row => (!row.disabled ? this.selection.select(row) : ''));
  }
  public handleChecked(row: any) {
    if (!row.disabled) {
      this.selection.toggle(row);
    }
  }
  public getReminderSent(reminderDetails: any) {
    // [{ReminderSendStatus: "Not Sent", ReminderDueDate: "02-Feb-2022", ReminderId: 0}]
    const reminderSents = [];
    if (reminderDetails && reminderDetails.length > 0) {
      reminderDetails.forEach(reminder => {
        if (reminder.ReminderSendStatus === 'Delivered') {
          let reminderSentDate = reminder.ReminderSendDate ? reminder.ReminderSendDate : reminder.ReminderDeliveryFailedDate ? reminder.ReminderDeliveryFailedDate : reminder.ReminderDueDate;
          reminderSents.push(this.appUtils.formatDateWithTime(reminderSentDate));
        }
      });
    } else {
      reminderSents.push('');
    }
    return reminderSents.join(' / ');
  }
  public getReminderPlanned(reminderDetails: any) {
    const reminderPlanned = [];
    if (reminderDetails && reminderDetails.length > 0) {
      reminderDetails.forEach(reminder => {
        // if (reminder.ReminderSendStatus === 'Not Sent') {
          reminderPlanned.push(this.appUtils.formatDateWithTime(reminder.ReminderDueDate));
        // }
      });
    } else {
      reminderPlanned.push('');
    }
    return reminderPlanned.join(' / ');
  }

  public gotoContactDetailsPage(row) {
    let rowData = {
      customerData: row,
      isSetCom: this.isSetCom,
      notificationStatus:  this.isAddRecipientDisabled,
      notificationData: this.notificationDetails.notificationData
    };
    this.router.navigateByUrl('/contact-details', { state: { customerDetails: rowData, accDataObj: this.accDataObj } });
  }

  public filterSourceTable(filterValue: any) {
    let datesent_start = this.appUtils.formatDateOnly(filterValue.dateSent_sdate);
    let datesent_end = this.appUtils.formatDateOnly(filterValue.dateSent_edate);

    let delivered_sdate = this.appUtils.formatDateOnly(filterValue.dateDelivered_sdate);
    let delivered_edate = this.appUtils.formatDateOnly(filterValue.dateDelivered_edate);

    let dateRead_sdate = this.appUtils.formatDateOnly(filterValue.dateRead_sdate);
    let dateRead_edate = this.appUtils.formatDateOnly(filterValue.dateRead_edate);

    let feedbackReceived_sdate = this.appUtils.formatDateOnly(filterValue.feedbackReceived_sdate);
    let feedbackReceived_edate = this.appUtils.formatDateOnly(filterValue.feedbackReceived_edate);

    if (filterValue.statusFilters.length < 1 && filterValue.dateSent_sdate == '' && 
    filterValue.dateDelivered_sdate == '' && filterValue.dateRead_sdate && filterValue.feedbackReceived_sdate) {
      this.dataSource.data = this.contactDetails;
    } else {
      const statusFilterArray = this.contactDetails.filter(data => filterValue.statusFilters.includes(data.Status) || filterValue.statusFilters == '');

      const datedeliveredFilterArray = statusFilterArray.filter(data => (this.appUtils.formatDateOnly(data.DateDelivered) >= delivered_sdate && this.appUtils.formatDateOnly(data.DateDelivered) <= delivered_edate) || filterValue.dateDelivered_sdate == '');

      const datesentFilterArray = datedeliveredFilterArray.filter(data => (this.appUtils.formatDateOnly(data.DateSent) >= datesent_start && this.appUtils.formatDateOnly(data.DateSent) <= datesent_end) || filterValue.dateSent_edate == '');

      const datereadFilterArray = datesentFilterArray.filter(data => (this.appUtils.formatDateOnly(data.DateRead) >= dateRead_sdate && this.appUtils.formatDateOnly(data.DateRead) <= dateRead_edate) || filterValue.dateRead_sdate == '');
      const feedbackReceivedFilterArray = datereadFilterArray.filter(data => (this.appUtils.formatDateOnly(data.FeedbackReceived) >= feedbackReceived_sdate && this.appUtils.formatDateOnly(data.FeedbackReceived) <= feedbackReceived_edate) || filterValue.feedbackReceived_sdate == '');
      this.dataSource.data = feedbackReceivedFilterArray.filter(data => this.appUtils.getLowerCase(data.DateRead) || this.appUtils.getLowerCase(data.FeedbackReceived) || this.appUtils.getLowerCase(data.Status) || this.appUtils.getLowerCase(data.DateDelivered) || this.appUtils.getLowerCase(data.DateSent));

      // console.log('Filtered Table Data', this.dataSource.data);
    }
    this.changeDetectorRef.detectChanges();
  }

  public displayStatus(status) {
    const statusText = status ? status : 'Pending';
    return statusText;
  }

  public ndResendNotification(): void {
    let selectedItems = this.selection.selected.filter(item => item.Status !== "Feedback Received" && item.Status !== 'Completed');
    
    if(selectedItems.length !== 0){
      const notificationId = this.notificationDetails.notificationData[0].NotificationId;
      const contactNotificationId = [];
      this.notificationDetails.contactData.map((item) => {
        selectedItems.some((elm) => {
          if(elm.CustomerContactEmail === item.CustomerContactEmail && elm.CustomerId === item.CustomerId){
            return contactNotificationId.push(item.ContactNotificationId)
          }
        });
      });
      this.executeResendDetailsData(selectedItems, notificationId, contactNotificationId);
      this.oneSnackBar.open('Resend is not allowed for contacts in "Feedback received" and "Completed" Status.', OneSnackBarType.INFO, '', { duration: 5000 });
    }else{
      this.oneSnackBar.open('You cannot resend for contacts in "Feedback received" status.', OneSnackBarType.ERROR, '', { duration: 5000 });
    }
  }

  public executeResendDetailsData(selectedItems, notificationId, contactNotificationId): void {
    let displayedColumns = ['CustomerId', 'CustomerName', 'CustomerContactName','CustomerContactEmail'];
    const resendData = {
      selectedItems,
      notificationId,
      contactNotificationId
    }
    this.resendDialog.open(ResendDetailsComponent, {
      data: { tableData: resendData, columnData: displayedColumns },
      disableClose: true,
      autoFocus: false,
      restoreFocus: false,
      width: '80vw',
      maxWidth: '80vw',
      minWidth: '60vw'
    });
  }

}
